import React, { useRef, useState, useEffect } from 'react'
import {
    Dialog,
    DialogTitle,
    Backdrop,
    CircularProgress,
    Grid,
    Button,
    Typography,
    DialogContent,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf"
import { useFLInvoiceDataContext } from '../../context/FreelancerInvoiceDataContext';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import useStyles from "../../themes/style.js";
import InterFont from "../../fonts/Inter.ttf";
import Lottie from 'lottie-react'
import SuccessMsg from "../../images/lootie/success.json"
import ErrorMsg from "../../images/lootie/failure.json"
import WarningMsg from "../../images/lootie/warning.json"
import { ArrowBackIosOutlined } from '@material-ui/icons';

const AlertMessagePopup = ({ alertOpen, handleAlertClose, alertTitle, alertMessage, alertImage }) => {
    const classes = useStyles();

    return (
        <Dialog
            // onClose={handleDeleteClose}
            aria-labelledby="dialog-title"
            open={alertOpen}
            width="md"
            PaperProps={{
                style: {
                    width: "100%",
                },
            }}
        >
            <DialogTitle>
                <div className={classes.center} style={{ paddingTop: "15px" }}>
                    <Typography style={{ fontSize: "1.3rem", fontWeight: 500 }}>
                        {alertTitle}
                    </Typography>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className={classes.center}>
                    <Lottie
                        style={{ width: '100px' }}
                        animationData={alertImage}
                        loop={true}
                        autoplay={true}
                    />
                </div>
                <Typography variant="body1" className={classes.center}>
                    {alertMessage}
                </Typography>

                <Grid className={classes.sendWhatsapp}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={(e) => { handleAlertClose() }}
                    >
                        Done
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const FreelancerInvoice = () => {

    const token = localStorage.getItem("token")
    const decode = jwtDecode(token)
    const classes = useStyles();
    const history = useHistory()
    const todayCurrentDate = new Date();
    const yyyy = todayCurrentDate.getFullYear();
    let mm = todayCurrentDate.getMonth() + 1; // Months start at 0!
    let dd = todayCurrentDate.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const invoiceTodayDate = dd + '/' + mm + '/' + yyyy;

    const reportTemplateRef = useRef(null);
    const fileInputRef = useRef(null);

    const handleOpenSignature = () => {
      fileInputRef.current.click();
    };

    const [signImage, setSignImage] = useState(null)
    const [loader, setLoader] = useState(false);
    const { invoiceItemData } = useFLInvoiceDataContext();

    const checkedItems = invoiceItemData.flatMap(item =>
        item.recordsValues.filter(record => record.checked)
    );

    const checkedItemIds = invoiceItemData.flatMap(item =>
        item.recordsValues.filter(record => record.checked).map(record => record.id)
    );

    let totalCVShare = 0;
    let totalFinalInterview = 0;
    let totalCandidateHired = 0;

    // Calculate the totals for each reason code
    checkedItems.forEach(record => {
        switch (record.reason) {
            case 303:
                totalCVShare += record.value;
                break;
            case 307:
                totalFinalInterview += record.value;
                break;
            case 309:
                totalCandidateHired += record.value;
                break;
            default:
                break;
        }
    });
    const totalCoinsIn = totalCVShare + totalFinalInterview + totalCandidateHired;

    const styles = {
        masterContainer: {
            minWidth: "800px",
            minHeight: "1000px",
            maxWidth: "800px",
            margin: "auto",
            padding: "16px",
            border: "1px solid #eee",
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "'Inter', sansSerif",
            color: "#555",
            backgroundColor: "#F9FAFC",
            filter: totalCoinsIn < 100 ? "blur(6px)" : "blur(0px)"
        }
    }

    const [freelancerBankDetails, setFreeLancerBankDetails] = useState([]);

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertImage, setAlertImage] = useState(null);
    const [handleAlertClose, setHandleAlertClose] = useState(() => () => setAlertOpen(false));

    const showAlert = (title, message, image, customCloseHandler) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertImage(image);
        setAlertOpen(true);
        setHandleAlertClose(() => customCloseHandler); // Set the custom close handler
    };

    const notify = (type, customMessage) => {
        switch (type) {
            case 'success':
                showAlert('Success', customMessage, SuccessMsg, () => {
                    history.push("/app/claim_coins");
                    setAlertOpen(false);
                });
                break;
            case 'error':
                showAlert('Error', customMessage, ErrorMsg, () => {
                    setAlertOpen(false);
                });
                break;
            case 'warning':
                showAlert('Warning', customMessage, WarningMsg, () => {
                    setAlertOpen(false);
                });
                break;
            default:
                break;
        }
    };

    const [invoiceNumber, setInvoiceNumber] = useState({
        invoiText: "",
        invoiInt: "",
    });


    useEffect(() => {
        async function getBankDetails() {
            setLoader(true);
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER}recruiter/getBankDetails`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: token,
                        },
                    }
                );
                setLoader(false);

                if (response.data.status === true) {
                    if (response.data.data.bankName !== "") {
                        setFreeLancerBankDetails(response.data.data);
                    }
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        }
        async function getUniqueIdForInvoice() {
            setLoader(true);
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER}recruiter/getUniqueIdForInvoice`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: token,
                        },
                    }
                );
                setLoader(false);

                if (response.data.status === true) {
                    setInvoiceNumber({
                        invoiText: response.data.invoiText,
                        invoiInt: response.data.invoiInt,
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        }
        getBankDetails()
        getUniqueIdForInvoice()
    }, []);

    async function handleRedeemCoins(pdfBlob, doc) {
        setLoader(true);
        const formData = new FormData();
        const invoiceFIle = new File([pdfBlob], `Invoice${Date.now()}.pdf`);
        formData.append('invoice', invoiceFIle);
        formData.append('redeemValue', totalCoinsIn);
        checkedItemIds.forEach((val, index) => {
            formData.append(`record_ids[${index}]`, val);
        })
        formData.append('invoiInt', invoiceNumber.invoiInt);
        formData.append('invoiText', invoiceNumber.invoiText);
        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER}recruiter/redeemCoins`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': token,
                },
            });

            if (response.data.status === true) {
                notify('success', response.data.message, SuccessMsg)
                doc.save(`Invoice${Date.now()}.pdf`);
            } else {
                notify('error', response.data.message, ErrorMsg)
            }

        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setLoader(false);
        }
    }

    const handleGeneratePdf = async () => {
        if (!signImage) {
            setAlertOpen(true)
            notify('error', 'In Invoice please Attach your Signature(your signature in image format is also ok), Less than 1 MB in size', ErrorMsg)
            return
        }
        const doc = new jsPDF({
            orientation: "portrait",
            unit: 'pt',
            format: 'a4',
            compress: true,
            lineHeight: 1.2
        });

        doc.addFont(InterFont, 'Inter', 'normal');
        doc.setFont('Inter');
        const element = reportTemplateRef.current;
        if (element) {
            await doc.html(element, {
                callback: (doc) => {
                    const pdfBlob = doc.output('blob');
                    handleRedeemCoins(pdfBlob,doc)

                },
                x: 10,
                y: 10,
                html2canvas: {
                    scale: 0.72, // Adjust the scale for better quality
                    logging: true, // Enable logging for debugging
                    useCORS: true,
                    letterRendering: true,
                },
                windowWidth: 800,
            });
        }
    };

    const getSignature = (event) => {
        const file = event.target.files[0]
        const cachedURL = URL.createObjectURL(file);
        setSignImage(cachedURL)
    }

    return (
        <>
            <div ref={reportTemplateRef} style={styles.masterContainer}>
                <table style={{ fontSize: "12px", lineHeight: "20px" }}>
                    <thead>
                        <tr>
                            <td colSpan="2" style={{ padding: "0 16px 0px 16px" }}> <h1 style={{ color: "#1A1C21", fontSize: "22px", fontStyle: "normal", fontWeight: 600, lineHeight: "normal", textAlign: 'center' }}>Invoice</h1></td>
                        </tr>
                        <tr>
                            <td style={{ padding: "18px 16px 18px 16px" }}>
                                <p style={{ color: "#1A1C21", fontWeight: 700, margin: 0 }}>Bill From:</p>
                                <h1 style={{ color: "#1A1C21", fontSize: "16px", fontStyle: "normal", fontWeight: 600, lineHeight: "normal" }}>
                                    {decode.firstName + " " + decode.lastName} </h1>
                                <p>{decode.email}</p>
                                <p>{decode.mobile}</p>
                            </td>
                            <td style={{ padding: "0 16px 18px 185px", textAlign: "start" }}>
                                <p style={{ color: "#1A1C21", fontWeight: 700, margin: 0, visibility: 'hidden' }}>Bill From:</p>
                                <p style={{ color: "#1A1C21", fontWeight: 700, textAlign: "start" }}>Invoice number</p>
                                <p style={{ color: "#5E6470", margin: 0 }}>{invoiceNumber.invoiText + invoiceNumber.invoiInt}</p>
                                <p style={{ color: "#1A1C21", fontWeight: 700, }}>Invoice Date</p>
                                <p style={{ color: "#5E6470", margin: 0 }}>{invoiceTodayDate}</p>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                <table style={{ backgroundColor: "#FFF", padding: "20px 16px", border: "1px solid #D7DAE0", width: "100%", borderRadius: "12px", fontSize: "12px", lineHeight: "20px", tableLayout: "fixed" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ verticalAlign: 0, width: '35%', paddingRight: "20px", paddingBottom: "35px" }}>
                                                <p style={{ color: "#1A1C21", fontWeight: 700 }}>Bill To:</p>
                                                <p style={{ color: "#1A1C21", fontWeight: 700, margin: 0 }}>Resource Access Management Solutions Pvt Ltd.</p>
                                                <p style={{ color: "#5E6470", margin: 0 }}> 26, Kattabomman Street, Radha Nagar,<br /> Chromepet Chennai -44</p>
                                            </td>
                                            {/* <td  style={{ verticalAlign: "top", paddingRight: "20px", paddingBottom: "35px" }}>
                                            </td> */}
                                            <td colSpan="2" style={{ verticalAlign: "top", padding: "0 0px 35px 195px", textAlign: "start" }}>
                                                <p style={{ color: "#1A1C21", fontWeight: 700, margin: 0, visibility: 'hidden' }}>Bill From:</p>
                                                <table style={{ tableLayout: "fixed", width: "-webkit-fill-available" }}>
                                                    <tr style={{ paddingTop: "12px", }}>
                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>GST Number</th>
                                                        <td style={{ textAlign: "right" }}>{"33AACCR7379G1Z6"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>PAN Number</th>
                                                        <td style={{ textAlign: "right" }}>{"AACCR7379G"}</td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <td style={{ paddingBottom: "13px" }} colSpan="2">
                                                <p style={{ color: "#5E6470" }}>Invoice number </p>
                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}>{invoiceNumber.invoiText + invoiceNumber.invoiInt}</p>
                                            </td>
                                            <td style={{ textAlign: "end", paddingBottom: "13px" }}>
                                                <p style={{ color: "#5E6470" }}>Invoice date</p>
                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}>{invoiceTodayDate}</p>
                                            </td>
                                        </tr> */}
                                        <tr>
                                            <td colSpan="3">
                                                <table style={{ width: "100%", borderSpacing: 0 }}>
                                                    <thead>
                                                        <tr style={{ textTransform: "uppercase" }}>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", fontSize: "10px" }}>Item Details</td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "80px", fontSize: "10px" }}>CV Share
                                                            </td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "100px", fontSize: "10px", margin: "10px" }}>Final Interview <br /> Turn-up
                                                            </td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "80px", fontSize: "10px" }}>Candidate Hired
                                                            </td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", textAlign: "end", width: "60px" }}>
                                                                Total <br />
                                                                Coins</td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", textAlign: "end", width: "60px" }}>
                                                                Rate <br />
                                                                (INR)</td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", textAlign: "end", width: "80px" }}>
                                                                Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ paddingBlock: "12px" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}>Total No of Candidates - {invoiceItemData.length}</p>
                                                            </td>
                                                            <td style={{ paddingBlock: "12px" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}> {totalCVShare}</p>
                                                            </td>
                                                            <td style={{ paddingBlock: "12px" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}> {totalFinalInterview}</p>
                                                            </td>
                                                            <td style={{ paddingBlock: "12px" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}>{totalCandidateHired}</p>
                                                            </td>
                                                            <td style={{ paddingBlock: "12px", textAlign: "end" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}> {totalCoinsIn}</p>
                                                            </td>
                                                            <td style={{ paddingBlock: "12px", textAlign: "end" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}> ₹5.00</p>
                                                            </td>
                                                            <td style={{ paddingBlock: "12px", textAlign: "end" }}>
                                                                <p style={{ fontWeight: 700, color: "#1A1C21" }}>₹{totalCoinsIn * 5}</p>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td style={{ padding: "12px 0", borderTop: "1px solid #D7DAE0" }}></td>
                                                            <td style={{ padding: "12px 0", borderTop: "1px solid #D7DAE0" }}></td>
                                                            <td style={{ padding: "12px 0", borderTop: "1px solid #D7DAE0" }}></td>
                                                            <td style={{ borderTop: "1px solid #D7DAE0" }} colSpan="5">
                                                                <table style={{ width: "100%", borderSpacing: 0 }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th style={{ paddingTop: "12px", textAlign: "start", color: "#1A1C21" }}>
                                                                                Subtotal</th>
                                                                            <td style={{ paddingTop: "12px", textAlign: "end", color: "#1A1C21;" }}>
                                                                                ₹{totalCoinsIn * 5}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th style={{ padding: "12px 0", textAlign: "start", color: "#1A1C21" }}>
                                                                                GST in items (0%)</th>
                                                                            <td style={{ padding: "12px 0", textAlign: "end", color: "#1A1C21" }}>
                                                                                ₹0.00</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tfoot>
                                                                        <tr>
                                                                            <th style={{ padding: "12px 0 30px 0", textAlign: "start", color: "#1A1C21", borderTop: "1px solid #D7DAE0" }}>
                                                                                Total Price</th>
                                                                            <th style={{ padding: "12px 0 30px 0", textAlign: "end", color: "#1A1C21", borderTop: "1px solid #D7DAE0" }}>
                                                                                ₹ {totalCoinsIn * 5}</th>
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr style={{ paddingTop: '20px' }}>
                                                            <td>
                                                                <img src={signImage} style={{ width: "80px" }} width="100%" alt='signature_image' />
                                                                <p>
                                                                    <input 
                                                                        type='file'
                                                                        id="icon-button-profile"
                                                                        accept=".jpg,.jpeg,.png"
                                                                        style={{ display: "none" }}
                                                                        ref={fileInputRef}
                                                                        onChange={(event) => getSignature(event)}
                                                                    />
                                                                    <label htmlFor="icon-button-profile">
                                                                        <button className='signature_button' onClick={handleOpenSignature} aria-label="upload picture">
                                                                            Signature
                                                                        </button>
                                                                    </label>
                                                                </p>
                                                                {/* <p style={{ color: "#1A1C21", fontWeight: 700 }}>Signature </p> */}

                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td colSpan="4" style={{ textAlign: 'end', paddingBottom: "35px", paddingTop: "12px", borderTop: "1px solid #D7DAE0" }}>
                                                                <table style={{ tableLayout: "fixed", width: "-webkit-fill-available" }}>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21", fontSize: '16px' }}>Bank Details:</th>
                                                                    </tr>
                                                                    <tr style={{ paddingTop: "12px", }}>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>Bank Name</th>
                                                                        <td style={{ textAlign: "right" }}>{freelancerBankDetails.bankName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>Account Number</th>
                                                                        <td style={{ textAlign: "right" }}>{freelancerBankDetails.accountNumber}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>IFSC Code</th>
                                                                        <td style={{ textAlign: "right" }}>{freelancerBankDetails.ifscCode}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>MICR Code</th>
                                                                        <td style={{ textAlign: "right" }}>{freelancerBankDetails.micrCode}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>GST Number</th>
                                                                        <td style={{ textAlign: "right" }}>{freelancerBankDetails.gstNumber}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", color: "#1A1C21" }}>PAN Number</th>
                                                                        <td style={{ textAlign: "right" }}>{freelancerBankDetails.panNumber}</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <table style={{ fontSize: "12px", lineHeight: "20px", marginTop: "250px" }}>
                    <tbody>
                        <tr>
                            <td>
                                <table style={{ backgroundColor: "#FFF", padding: "20px 16px", border: "1px solid #D7DAE0", width: "100%", borderRadius: "12px", fontSize: "12px", lineHeight: "20px", tableLayout: "fixed" }}>
                                    <tbody>

                                        <tr>
                                            <td colSpan="3">
                                                <table style={{ width: "100%", borderSpacing: 0 }}>
                                                    <thead>
                                                        <tr style={{ textTransform: "uppercase" }}>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", fontSize: "10px" }}>Item Details</td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "80px", fontSize: "10px" }}>
                                                            </td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "100px", fontSize: "10px", margin: "10px" }}>
                                                            </td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "80px", fontSize: "10px" }}>
                                                            </td>
                                                            <td style={{ padding: "8px 0", borderBlock: "1px solid #D7DAE0", width: "80px", fontSize: "10px" }}>
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invoiceItemData.map((item) => {

                                                            const candidateFullName = `${item.candidate.candidateDetail.firstName} ${item.candidate.candidateDetail.lastName}`;
                                                            const requirementFullName = item.requirement.requirementName;

                                                            const recordsValues = item.recordsValues;

                                                            const getValueAndDate = (reason) => {
                                                                const record = recordsValues.find(record => record.reason === reason);
                                                                if (record && record.checked) {
                                                                    return {
                                                                        value: record.value,
                                                                        date: moment(record.createdAt).format("DD-MM-YYYY")
                                                                    };
                                                                }
                                                                return {
                                                                    value: '-',
                                                                    date: '-'
                                                                };
                                                            };
                                                            const cvShareValueIndividual = getValueAndDate(303);
                                                            const finalInterviewValueIndividual = getValueAndDate(307);
                                                            const candidateHiredValueIndividual = getValueAndDate(309);

                                                            return (
                                                                <tr key={item.id}>
                                                                    <td style={{ paddingBlock: "12px", width: "250px" }}>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>{candidateFullName}</p>
                                                                        <p style={{ color: "#5E6470" }}>{requirementFullName}</p>
                                                                    </td>
                                                                    <td style={{ paddingBlock: "12px", width: "250px" }}>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>CV Share</p>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>Final Interview Turn-up</p>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>Candidate Hired</p>
                                                                    </td>
                                                                    <td style={{ paddingBlock: "12px", width: "150px" }}>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>{cvShareValueIndividual.date}</p>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>{finalInterviewValueIndividual.date}</p>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>{candidateHiredValueIndividual.date}</p>
                                                                    </td>
                                                                    <td style={{ paddingBlock: "12px", width: "50px" }}>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}> {cvShareValueIndividual.value} </p>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>{finalInterviewValueIndividual.value}</p>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>{candidateHiredValueIndividual.value}</p>
                                                                    </td>
                                                                    <td style={{ paddingBlock: "12px", textAlign: "end" }}>
                                                                        <p style={{ fontWeight: 700, color: "#1A1C21" }}>   </p>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <AlertMessagePopup
                alertOpen={alertOpen}
                alertTitle={alertTitle}
                alertMessage={alertMessage}
                alertImage={alertImage}
                handleAlertClose={handleAlertClose}
            />
            <Backdrop className={classes.backdrop} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <div style={{ minWidth: "800px", display: totalCoinsIn < 100 ? "none" : "block", maxWidth: "800px", padding: "10px", margin: "auto", fontFamily: "'Inter', sansSerif" }}>
                <Typography variant="body1">
                    Check the all the details before you claim
                </Typography>
            </div>
            <div className={classes.center} style={{ padding: "10px" }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ width: '100px', display: totalCoinsIn < 100 ? "none" : "block" }}
                    onClick={handleGeneratePdf}
                >
                    Claim
                </Button>
            </div>
            <div className={classes.center} style={{ position: "fixed", top: 0, bottom: 0, left: 0, right: 0, display: totalCoinsIn < 100 ? "flex" : "none" }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<ArrowBackIosOutlined style={{ width: '20px', height: '20px' }} />}
                    style={{ width: '120px', padding: "10px !important" }}
                    onClick={() => history.goBack()}
                >
                    Go Back
                </Button>
            </div>
        </>
    )
}

export default FreelancerInvoice;